import { RouterProvider } from 'react-router-dom';

// project-imports
import router from 'routes';
import ThemeCustomization from 'themes';

import Locales from 'components/Locales';
import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';
import Customization from 'components/customization';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';
import Metrics from 'metrics';

// auth-providers
import { AuthProvider as MineACSAuthProvider } from 'features/auth';
import { RealtimeProvider } from 'features/realtime';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <>
      <ThemeCustomization>
        <RTLLayout>
          <Locales>
            <ScrollTop>
              <MineACSAuthProvider>
                <RealtimeProvider>
                  <Notistack>
                    <RouterProvider router={router} />
                    <Customization />
                    <Snackbar />
                  </Notistack>
                </RealtimeProvider>
              </MineACSAuthProvider>
            </ScrollTop>
          </Locales>
        </RTLLayout>
      </ThemeCustomization>

      <Metrics />
    </>
  );
}
